import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogBody, DialogFooter, DialogDescription } from '../../../ui/dialog';
import { Button } from '../../../ui/button';
import { Badge } from '../../../ui/badge';
import { Send, Mail, CheckCircle2 } from 'lucide-react';

const SendInvitationsDialog = ({ open, onOpenChange, campaign }) => {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const send = () => {
    setSending(true);
    setTimeout(() => {
      setSending(false);
      setSent(true);
    }, 1500);
    setTimeout(() => {
      onOpenChange(false);
      setSent(false);
    }, 3000);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='max-w-md' onClose={() => onOpenChange(false)}>
        <DialogHeader>
          <DialogTitle>Send invitations</DialogTitle>
          <DialogDescription>
            Each employee will receive an email with a unique, tokenised survey link. No account required.
          </DialogDescription>
        </DialogHeader>

        <DialogBody>
          {!sent ? (
            <>
              <div className='rounded-lg border border-border p-4 mb-4'>
                <div className='text-xs text-muted-foreground mb-1'>Campaign</div>
                <div className='font-medium mb-3'>{campaign.name}</div>
                <div className='flex items-center gap-2 text-sm'>
                  <Badge variant='info' size='sm'>
                    <Mail size={10} strokeWidth={1.5} />
                    {campaign.invitedCount || 388} recipients
                  </Badge>
                  <span className='text-muted-foreground'>across {campaign.locationCount || 4} locations</span>
                </div>
              </div>

              <div className='text-xs text-muted-foreground space-y-1.5'>
                <div className='flex items-center gap-2'>
                  <CheckCircle2 size={12} strokeWidth={1.5} className='text-success' />
                  Emails sent through CYF transactional domain
                </div>
                <div className='flex items-center gap-2'>
                  <CheckCircle2 size={12} strokeWidth={1.5} className='text-success' />
                  Throttled to ~10 per second
                </div>
                <div className='flex items-center gap-2'>
                  <CheckCircle2 size={12} strokeWidth={1.5} className='text-success' />
                  Tokens expire on campaign close (re-sent on re-open)
                </div>
              </div>
            </>
          ) : (
            <div className='flex flex-col items-center py-6 text-center'>
              <div className='w-12 h-12 rounded-full bg-success-bg flex items-center justify-center text-success mb-4'>
                <CheckCircle2 size={20} strokeWidth={1.5} />
              </div>
              <div className='font-medium mb-1'>Invitations sent</div>
              <div className='text-xs text-muted-foreground'>
                {campaign.invitedCount || 388} employees will receive an email within a few minutes.
              </div>
            </div>
          )}
        </DialogBody>

        {!sent && (
          <DialogFooter>
            <Button variant='ghost' onClick={() => onOpenChange(false)} disabled={sending}>
              Cancel
            </Button>
            <Button onClick={send} loading={sending}>
              <Send size={14} strokeWidth={1.5} />
              {sending ? 'Sending...' : `Send ${campaign.invitedCount || 388} invitations`}
            </Button>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SendInvitationsDialog;
